import { createSlice } from '@reduxjs/toolkit';

const sectionInitial = () => ({
  data: [],
  loading: false,
  error: null,
  loaded: false,
});

const statesInitial = () => ({
  data: [],
  loading: false,
  error: null,
  country: null,
});

const initialState = {
  countries: {
    property: sectionInitial(),
    mailing: sectionInitial(),
  },
  states: {
    property: statesInitial(),
    mailing: statesInitial(),
  },
  zipLookup: {
    loading: false,
    error: null,
    lastResult: null,
  },
};

const addressSlice = createSlice({
  name: 'workkardForm/address',
  initialState,
  reducers: {
    fetchCountriesRequest(state, action) {
      const section = action.payload?.section;
      if (!section || !state.countries[section]) return;
      state.countries[section].loading = true;
      state.countries[section].error = null;
    },
    fetchCountriesSuccess(state, action) {
      const { section, data } = action.payload || {};
      if (!section || !state.countries[section]) return;
      state.countries[section].data = Array.isArray(data) ? data : [];
      state.countries[section].loading = false;
      state.countries[section].loaded = true;
      state.countries[section].error = null;
    },
    fetchCountriesFailure(state, action) {
      const { section, error } = action.payload || {};
      if (!section || !state.countries[section]) return;
      state.countries[section].loading = false;
      state.countries[section].loaded = true;
      state.countries[section].error = error || 'Failed to fetch countries';
    },

    fetchStatesRequest(state, action) {
      const { section, country } = action.payload || {};
      if (!section || !state.states[section]) return;
      state.states[section].loading = true;
      state.states[section].error = null;
      state.states[section].country = country || null;
    },
    fetchStatesSuccess(state, action) {
      const { section, country, data } = action.payload || {};
      if (!section || !state.states[section]) return;
      if (state.states[section].country !== country) return;
      state.states[section].data = Array.isArray(data) ? data : [];
      state.states[section].loading = false;
      state.states[section].error = null;
    },
    fetchStatesFailure(state, action) {
      const { section, error } = action.payload || {};
      if (!section || !state.states[section]) return;
      state.states[section].loading = false;
      state.states[section].error = error || 'Failed to fetch states';
    },
    clearStates(state, action) {
      const section = action.payload?.section;
      if (!section || !state.states[section]) return;
      state.states[section] = statesInitial();
    },

    zipLookupRequest(state) {
      state.zipLookup.loading = true;
      state.zipLookup.error = null;
    },
    zipLookupSuccess(state, action) {
      state.zipLookup.loading = false;
      state.zipLookup.lastResult = action.payload || null;
    },
    zipLookupFailure(state, action) {
      state.zipLookup.loading = false;
      state.zipLookup.error = action.payload?.error || 'Zip lookup failed';
    },
    clearZipLookup(state) {
      state.zipLookup = { loading: false, error: null, lastResult: null };
    },
  },
});

export const {
  fetchCountriesRequest,
  fetchCountriesSuccess,
  fetchCountriesFailure,
  fetchStatesRequest,
  fetchStatesSuccess,
  fetchStatesFailure,
  clearStates,
  zipLookupRequest,
  zipLookupSuccess,
  zipLookupFailure,
  clearZipLookup,
} = addressSlice.actions;

export default addressSlice.reducer;
